import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoadingService } from './services/loading.service';

import { LoginPageModule } from './pages/login/login.module';
import { LoginPage } from './pages/login/login.page';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginPage, data: { preload: true } },
  { path: 'logout', loadChildren: './pages/logout/logout.module#LogoutPageModule' },
  { path: 'comingsoon', loadChildren: './pages/comingsoon/comingsoon.module#ComingsoonPageModule' },
  { path: 'changepassword', loadChildren: './pages/changepassword/changepassword.module#ChangePasswordPageModule' },

  // { path: 'dashboard', loadChildren: './pages/dashboard/dashboard.module#DashboardPageModule', data: { name: '/dashboard' } },
  { path: 'dashboard', loadChildren: './pages/comingsoon/comingsoon.module#ComingsoonPageModule' },
  { path: 'settings', loadChildren: './pages/settings/settings.module#SettingsPageModule' },

  { path: 'list', loadChildren: './pages/list/list.module#ListPageModule', data: { name: '/list' } },
  { path: 'listeditable', loadChildren: './pages/listeditable/listeditable.module#ListEditablePageModule', data: { name: '/listeditable' } },

  { path: 'usergroupslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'usergroupsform', loadChildren: './pages/usergroupsform/form.module#FormPageModule', data: { name: '/usergroupsform' } },
  { path: 'userslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'usersform', loadChildren: './pages/usersform/usersform.module#UsersFormPageModule', data: { name: '/usersform' } },
  
  { path: 'warehouseslist', loadChildren: './pages/listeditable/listeditable.module#ListEditablePageModule' },
  { path: 'priceclasseslist', loadChildren: './pages/listeditable/listeditable.module#ListEditablePageModule' },
  { path: 'areaslist', loadChildren: './pages/listeditable/listeditable.module#ListEditablePageModule' },

  { path: 'itemcategorieslist', loadChildren: './pages/itemcategorieslist/form.module#FormPageModule' },

  { path: 'customerslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'customersform', loadChildren: './pages/customersform/form.module#FormPageModule', data: { name: '/customersform' } },

  { path: 'expensecategorieslist', loadChildren: './pages/expensecategorieslist/form.module#FormPageModule' },
  { path: 'supplierslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'suppliersform', loadChildren: './pages/suppliersform/form.module#FormPageModule', data: { name: '/suppliersform' } },
  { path: 'specialpromoslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'specialpromosform', loadChildren: './pages/specialpromosform/form.module#FormPageModule', data: { name: '/specialpromosform' } },
  { path: 'storeslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'storesform', loadChildren: './pages/storesform/form.module#FormPageModule', data: { name: '/storesform' } },
  { path: 'storewarehousesform', loadChildren: './pages/storewarehousesform/form.module#FormPageModule', data: { name: '/storewarehousesform' } },

  { path: 'expenseslist', loadChildren: './pages/comingsoon/comingsoon.module#ComingsoonPageModule' },
  { path: 'chartofaccountslist', loadChildren: './pages/comingsoon/comingsoon.module#ComingsoonPageModule' },
  { path: 'chartofaccountsform', loadChildren: './pages/chartofaccountsform/form.module#FormPageModule', data: { name: '/chartofaccountsform' } },

  { path: 'countrieslist', loadChildren: './pages/listeditable/listeditable.module#ListEditablePageModule' },
  { path: 'currencieslist', loadChildren: './pages/listeditable/listeditable.module#ListEditablePageModule' },
  { path: 'financialperiodslist', loadChildren: './pages/listeditable/listeditable.module#ListEditablePageModule' },

  { path: 'warehousetransferslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'warehousetransfersform', loadChildren: './pages/warehousetransfersform/form.module#FormPageModule', data: { name: '/warehousetransfersform' } },

  { path: 'inventoryadjustmentslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'inventoryadjustmentsform', loadChildren: './pages/inventoryadjustmentsform/form.module#FormPageModule', data: { name: '/inventoryadjustmentsform' } },

  { path: 'storeitembalanceslist', loadChildren: './pages/list/list.module#ListPageModule' },
// { path: 'suppliersform', loadChildren: './pages/suppliersform/form.module#FormPageModule', data: { name: '/suppliersform' } },

  { path: 'inventorystockcardslist', loadChildren: './pages/list/list.module#ListPageModule' },
// { path: 'suppliersform', loadChildren: './pages/suppliersform/form.module#FormPageModule', data: { name: '/suppliersform' } },

  { path: 'priceincreasesform', loadChildren: './pages/priceincreasesform/form.module#FormPageModule' },


  { path: 'quotationslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'salesorderslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'deliveryreceiptslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'invoiceslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'salesreturnslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'purchaseorderslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'purchasereturnslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'proformainvoiceslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'importationslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'reorderslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'deliveryissuanceslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'storepulloutslist', loadChildren: './pages/list/list.module#ListPageModule' },

  { path: 'quotationsform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/quotationsform' } },
  { path: 'salesordersform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/salesordersform' } },
  { path: 'deliveryreceiptsform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/deliveryreceiptsform' } },
  { path: 'invoicesform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/invoicesform' } },
  { path: 'salesreturnsform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/salesreturnsform' } },
  { path: 'purchaseordersform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/purchaseordersform' } },
  { path: 'purchasereturnsform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/purchasereturnsform' } },
  { path: 'proformainvoicesform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/proformainvoicesform' } },
  { path: 'importationsform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/importationsform' } },
  { path: 'reordersform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/reordersform' } },
  { path: 'deliveryissuancesform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/deliveryissuancesform' } },
  { path: 'storepulloutsform', loadChildren: './pages/mainform/form.module#FormPageModule', data: { name: '/storepulloutsform' } },

  { path: 'collectionslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'salescreditmemoslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'salesdebitmemoslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'counterreceiptslist', loadChildren: './pages/list/list.module#ListPageModule' },

  
  { path: 'billslist', loadChildren: './pages/list/list.module#ListPageModule' },
  
  { path: 'disbursementslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'purchasecreditmemoslist', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'purchasedebitmemoslist', loadChildren: './pages/list/list.module#ListPageModule' },

  
  { path: 'storewarehousetransferslist', loadChildren: './pages/list/list.module#ListPageModule' },

  // { path: 'barcodecheckslist', loadChildren: './pages/list/list.module#ListPageModule' },
// { path: 'suppliersform', loadChildren: './pages/suppliersform/form.module#FormPageModule', data: { name: '/suppliersform' } }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: LoadingService }),
    LoginPageModule
  ],
  exports: [RouterModule],
  providers: [LoadingService]
})
export class AppRoutingModule {}